import {
    bigQueryListener,
    mixpanelListener,
    loggerListener,
    statsListener
} from '@fiverr-private/obs';
import { getContext } from '@fiverr-private/fiverr_context';
import getMetaTagValue from '../../../lib/getMetaTagValue';

const mode = getMetaTagValue('app_environment');
const facility = getMetaTagValue('fiverrmeta:facility');
const relay = getMetaTagValue('browser_stats_api_v1');
const logLevel = getMetaTagValue('fiverrmeta:log_level');
const mixpanelToken = getMetaTagValue('gtm:mixpanel_token');

loggerListener({
    host: relay,
    facility,
    mode,
    logLevel
});

bigQueryListener({
    host: '/api/v1/activities',
    facility,
    mode
});

mixpanelListener({
    token: mixpanelToken,
    mode,
    userId: getContext().userId,
    userGuid: getContext().userGuid
});

statsListener({
    host: relay,
    mode
});
